<template>
     <div class="slide-verify">
        <Tag style="text-align: center;" color="volcano" size="large">请完成滑块验证。</Tag>
        <!-- <div v-if="slideInfo.token" class="puzzle-container" :style="{width:slideInfo.width+'px',height:slideInfo.height+'px' }">
            <div class="background-image" :style="{ backgroundImage: 'url(data:image/png;base64,'+ slideInfo.shadeImage + ')' }"></div>
            <div class="slider" ref="slider"
                :style="{backgroundImage: 'url(data:image/png;base64,'+ slideInfo.cutoutImage + ')' ,top:slideInfo.y+'px',left: sliderLeft + 'px',width:slideWidth+'px',height:slideHeight+'px' }"
                @mousedown="onMouseDown" @touchstart.prevent="onTouchStart">
                <img v-show="false" ref="slideblock" :src="'data:image/png;base64,'+slideInfo.cutoutImage" >
            </div>
        </div> -->

            <!-- 结果展示区域 -->
            <!-- <div v-if="showResult" class="result-box">
                <p>【randstr】-> {{ result.randstr }}</p>
                <p>【ticket】-> {{ result.ticket }}</p>
            </div> -->
        <div class="footer">
            <!-- 验证码按钮 -->
            <!-- <button ref="captchaBtn" @click="showCaptcha">显示验证码</button> -->
            <Button type="warning" @click="showCaptcha">显示验证码</Button>
            <!--
            <Button type="warning" @click="getSliderInfo">刷新验证码</Button>
            <Button type="primary" @click="save" >提交</Button> -->
        </div>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
  </template>

<script>
export default {
    props: {
        /**
         * clientConfig 配置信息，说明
         * { faceMinCount: 2, // 跳过次数
         *   skip: true, // 是否需要跳过
         *   blank: false, // 路由是否重新打开页面
         *   examRecordId: examRecordId, // 考试 ID
         *   coursewareCode: coursewareCode, // 课件 ID
         *   chapterId: this.playedVideoChapter.id, // 章节 ID
         *   faceSignInScene: FACE_SIGNIN_SCENE.BEFORE_EXAMINATION // 签到场景
         *   route: { name | path | params } // 路由信息
         * }
         */
        clientConfig: { type: Object },
    },
    name: 'SlideHeBeiVerify',
    data() {
        return {
            spinShow: false,
            isSliding: false,
            captchaAppId: '', // 替换为你的CaptchaAppId
            aidEncrypted:'', // 加密串
            captchaInstance: null,
            showResult: false,
            msg: '',
            result: {},
            slideInfo:{
            }
        };
    },
    mounted() {
        this.getSliderInfo();
    },
    methods: {
        getSliderInfo() {
            this.spinShow=true;
            let that=this;
            // that.slideInfo.token='';
            // that.sliderLeft=0;
            // Utils.success('成功提示', '获取成功,请尽快验证');
            // console.log(that.clientConfig);
            that.slideInfo={};
            that.captchaAppId='';
            that.aidEncrypted='';
            that.msg='';
            // const data = { 'attributes': {
            //     'codeId': '6a264c555c1c4606b232ced1fefe5b8d',
            //     'secret': '4ef0d2986324e5a97aa41b40a8a6caf7',
            //     'timestamp': 1741675079793,
            //     'captchaappid': '196955686',
            //     'aidEncrypted':'6a264c555c1c4606b232ced1fefe5b8d'
            // },
            // 'msg': '获取成功',
            // 'msgCode': '1',
            // 'success': true
            // };

            // that.captchaAppId=data.attributes.captchaappid;
            // that.aidEncrypted=data.attributes.aidEncrypted;
            // console.log('that.captchaappid', that.captchaappid);
            // console.log('that.aidEncrypted', that.aidEncrypted);
            // that.initCaptcha();
            // that.spinShow=false;
            $.ajax({
                type : 'post',
                url : that.clientConfig.getSlideUrl,
                dataType:'json',
                data:{
                    'cwCode': that.clientConfig.coursewareCode,
                    'userId': that.clientConfig.userId,
                    'type':1,
                },
                async: false,
                success : function(data) {
                    console.log('data', data);
                    that.spinShow=false;

                    if (data &&data.success) {
                        Utils.success('成功提示', '获取成功,请尽快验证');
                        that.slideInfo = data.attributes;
                        that.captchaAppId=data.attributes.captchaappid;
                        that.aidEncrypted=data.attributes.aidEncrypted;
                        that.initCaptcha();
                        // that.$nextTick(() => {
                        //     const sblock = that.$refs.slideblock;
                        //     console.log('sblock', sblock);
                        //     // const sblock = new Image();
                        //     // 图片加载完成后获取尺寸
                        //     sblock.onload = () => {
                        //         // console.log('图片宽度:', sblock.width);
                        //         // console.log('图片高度:', sblock.height);
                        //         that.slideWidth = sblock.width;
                        //         that.slideHeight = sblock.height;
                        //     };
                        //     // 触发图片加载（如果图片已经在浏览器缓存中，则不会触发onload事件）
                        //     if (sblock.complete) {
                        //         sblock.onload();
                        //     }
                        // });
                    } else {
                        if (data.msg=='该课程已经进行过滑块验证') {
                            that.msg='';
                            Utils.success('成功提示', '该课程已经进行过滑块验证');
                            that.$emit('on-complete');
                        } else {
                            Utils.warning('错误提示msgCode='+data.msgCode, data.msg);
                            that.msg=data.msg;
                        }
                    }
                },
                error: function(e) {
                    Utils.warning('异常提示', e);
                    that.spinShow=false;
                    // that.$Spin.hide();
                    // window.location='https://ce-study.hqjy.com/study/u/logout';
                }
            });
        },
        save() {
            let that=this;
            that.spinShow=true;
            // that.$Spin.hide();
            // that.getSliderInfo();
            // Utils.success('成功提示', '提交成功');
            // that.spinShow=false;
            // that.$emit('on-complete');
            // this.slideInfo.ticket= res.ticket;
            // this.slideInfo.randstr= res.randstr;
            $.ajax({
                type : 'post',
                url : that.clientConfig.sendSlideResultUrl,
                dataType:'json',
                data:{
                    'cwCode': that.clientConfig.coursewareCode,
                    'userId': that.clientConfig.userId,
                    'ticket': that.slideInfo.ticket,
                    'randstr': that.slideInfo.randstr,
                    'codeId':that.slideInfo.codeId,
                    'timestamp':that.slideInfo.timestamp,
                    'secret':that.slideInfo.secret,
                },
                async: false,
                success : function(data) {
                    that.spinShow=false;
                    // that.$Spin.hide();
                    if (data &&data.success) {
                        Utils.success('成功提示', '验证成功');
                        that.$emit('on-complete');
                    } else {
                        Utils.warning('错误提示', data.msg);
                        // that.getSliderInfo();
                    }
                },
                error: function(e) {
                    that.spinShow=false;
                    // that.$Spin.hide();
                    Utils.warning('异常提示', e);
                    // window.location='https://ce-study.hqjy.com/study/u/logout';
                }
            });
        },
        // 初始化验证码
        initCaptcha() {
            const script = document.createElement('script');
            script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js';
            script.onerror = this.loadErrorHandler;
            document.head.appendChild(script);
            console.log('this.captchaAppId', this.captchaAppId);
            script.onload = () => {
                this.captchaInstance = new TencentCaptcha(
                    this.captchaAppId,
                    this.callback,
                    { aidEncrypted:this.aidEncrypted, userLanguage: 'zh-cn' }
                );
            };
        },

        // 显示验证码
        showCaptcha() {
            if (this.msg) {
                Utils.warning('错误提示', this.msg);
            }
            if (!this.captchaInstance) {
                // this.$message.error('验证码加载中，请稍后重试');
                Utils.info('提示', '验证码加载中，请稍后重试');
                return;
            }

            try {
                this.captchaInstance.show();
            } catch (error) {
                this.loadErrorHandler();
            }
        },

        // 验证回调处理
        callback(res) {
            this.showResult = true;
            this.result = res;
            console.log('res', res);
            this.slideInfo.ticket= res.ticket;
            this.slideInfo.randstr= res.randstr;
            this.save();
            // 自动复制结果到剪贴板
            // this.copyToClipboard(res);
            // if (res.ret==0) {
            //     Utils.success('验证成功');
            // }
            // if (res.ret==2) {
            //     Utils.warning('关闭验证');
            // }
            // 2秒后自动关闭结果展示
            setTimeout(() => {
                this.showResult = false;
            }, 2000);
        },

        // 错误处理
        loadErrorHandler() {
            // this.$message.error('验证码加载失败，请检查网络连接');
            Utils.warning('验证码加载失败，请检查网络连接', e);
            console.error('验证码JS加载失败');
        },

        // 复制到剪贴板
        copyToClipboard(data) {
            const text = `【randstr】-> ${data.randstr} 【ticket】-> ${data.ticket}`;
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
    },

};
</script>

<style lang="scss" scoped>
.slide-verify{
    text-align: center;
    .tencent-captcha-dy__header-close{display:none;}
}
.result-box {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #f9f9f9;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}
</style>
